import { Component } from '@angular/core';
import { InputBase } from '../base/input-base';
import { ToggleSwitchChangeEvent } from 'primeng/toggleswitch';
@Component({
  selector: 'app-toggle-switch',
  template: `
    <p-toggleswitch
      id="toggleswitch"
      [(ngModel)]="value"
      [disabled]="isDisabled()"
      (onFocus)="onTouched()"
      (onBlur)="onTouched()"
      (onChange)="onChangeToggle($event)"
      [class]="styleClass"
      sty
    />
    <app-helper-text [errorMessage]="errorMessage" [showErrors]="showErrors" />
  `,
  styleUrl: './toggle-switch.component.scss',
})
export class ToggleSwitchComponent extends InputBase {
  protected onChangeToggle(event: ToggleSwitchChangeEvent) {
    this.onChange?.(event.checked);
  }

  get styleClass() {
    return this.showErrors ? 'ng-invalid ng-dirty' : '';
  }

  override writeValue(checked: boolean): void {
    this.value = checked;
  }
}
